import React from 'react';
import { TutorReportAndResolveIssueModal } from './tutor-report-and-resolve-issue-modal.component';
import { useTutorReportAndResolveIssueModalService } from './tutor-report-and-resolve-issue-modal.service';
import type { TutorReportAndResolveIssueModalContainerProps } from './tutor-report-and-resolve-issue-modal.types';

export const TutorReportAndResolveIssueModalContainer = (
  props: TutorReportAndResolveIssueModalContainerProps,
) => {
  const serviceProps = useTutorReportAndResolveIssueModalService(props);
  return <TutorReportAndResolveIssueModal {...serviceProps} />;
};
